<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">Resgate seu saldo via Pix!</h6>

    <p class="subtitle">
      Transfira o saldo da sua lista de presentes diretamente para a sua conta
      bancária por meio do Pix.<br />As transferências são gratuitas e
      ilimitadas.
    </p>

    <a
      @click="$emit('keepList')"
      href="https://ajuda.casar.com/support/solutions/articles/73000559543-como-funciona-o-recebimento-por-pix-"
      target="_blank"
      class="button is-primary mt-6"
    >
      Quero saber mais como transferir via Pix
    </a>
    <p>
      <a @click="$emit('disableList')" class="link" href="#">
        Quero desativar a minha lista de presentes
      </a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  methods: {},
}
</script>
